module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAMklEQVRIx2O4IyFHI8QwajT9jGbUaqcRGjWajkb/ec1PIzRqNB2NFpsUTCM0ajT9jAYAIHPCLZjOBccAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/mu.png
// module id = 884
// module chunks = 0